import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/dashcube': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M326.6 104l102.2-104v427c0 50.5-40.1 85-91.2 85h-227.2c-51.1 0-91.2-34.5-91.2-85v-229.5c0-50.2 40.1-93.5 91.2-93.5h216.2zM153.9 416.5v0.1h223.8l-51.1-52.3v-123.5c0-17.7-14.3-32.5-32-32.5h-140.7c-17.7 0-32.4 14.8-32.4 32.5v142.9c0 17.7 14.7 32.8 32.4 32.8z'
      }
    ]
  }
})
